

  <!-- Promotion details block  -->
  <ng-container *ngIf="dialogData.cntxt == 'promotion'; else showMessage">
    <h2 mat-dialog-title class="text-center text-capitalize">
    Promotion details
    <span class="float-end" (click)="onConfirmClick()"
      ><button mat-icon-button><i class="mi mi-close"></i></button
    ></span>
  </h2>
  <div class="row">
    <div class="col-xl-6 col-xxl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
      <div class="block-each">
        <h4 class="fs-5 text-capitalize">Promotion Name</h4>
        <span class="fs-6 text-capitalize">{{ promoName }}</span>
      </div>
    </div>
    <div class="col-xl-6 col-xxl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
      <div class="block-each">
        <h4 class="fs-5 text-capitalize">carrier</h4>
        <span class="fs-6 text-capitalize">{{ carrier }}</span>
      </div>
    </div>
  </div>
  <div class="row my-3">
    <div class="col-xl-6 col-xxl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
      <div class="block-each">
        <h4 class="fs-5 text-capitalize">Validity</h4>
        <span class="fs-6 text-capitalize"
          >{{ validityFrom | date }} - {{ validityTo | date }}</span
        >
      </div>
    </div>
    <div class="col-xl-6 col-xxl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
      <div class="block-each">
        <h4 class="fs-5 text-capitalize">Amount applicable</h4>
        <span class="fs-6 text-capitalize">{{ amountApplicable }}</span>
      </div>
    </div>
  </div>
  <div class="block-each">
    <h4 class="fs-5 text-capitalize">Promotion description</h4>
    <span
      class="fs-6 text-capitalize"
      [innerHTML]="promoDesc | nl2br: true"
    ></span>
  </div>
  </ng-container>


  <ng-template #showMessage>
    <h2 mat-dialog-title>
      {{ message | translate}}
    </h2>
    <mat-dialog-actions align="center" class="m-0">
      <button mat-raised-button color="primary" (click)="onConfirmClick()" tabindex="1" class="rounded-0 px-5 me-2">
        {{ confirmButtonText | translate }}
      </button>
      <button mat-raised-button mat-dialog-close tabindex="-1" class="rounded-0 px-5 ms-2">
        {{ cancelButtonText | translate }}
      </button>
    </mat-dialog-actions>
  </ng-template>